import React, { useState } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { api } from '../api/client'

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (password !== confirm) {
      setError('Passwörter stimmen nicht überein.')
      return
    }
    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen haben.')
      return
    }
    if (!token) {
      setError('Ungültiger Link. Bitte erneut „Passwort vergessen“ anfordern.')
      return
    }
    setLoading(true)
    try {
      await api.post('/auth/reset-password', { token, new_password: password })
      setSuccess(true)
      setTimeout(() => navigate('/login', { state: { message: 'Passwort wurde geändert. Bitte anmelden.' } }), 2000)
    } catch (err) {
      const msg = err?.message || ''
      if (msg.includes('Ungültiger') || msg.includes('abgelaufen')) {
        setError('Link ungültig oder abgelaufen. Bitte erneut anfordern.')
      } else {
        setError(msg || 'Passwort konnte nicht geändert werden.')
      }
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
        <div className="card-glass w-full max-w-md p-6 sm:p-8">
          <h1 className="text-center text-xl font-bold text-white">Passwort geändert</h1>
          <p className="mt-4 text-center text-white/80">Sie werden zur Anmeldung weitergeleitet…</p>
          <p className="mt-6 text-center">
            <Link to="/login" className="text-violet-300 hover:underline">Jetzt anmelden</Link>
          </p>
        </div>
      </div>
    )
  }

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
        <div className="card-glass w-full max-w-md p-6 sm:p-8">
          <h1 className="text-center text-xl font-bold text-white">Ungültiger Link</h1>
          <p className="mt-4 text-center text-white/80">Bitte fordern Sie einen neuen Link über „Passwort vergessen“ an.</p>
          <p className="mt-6 text-center">
            <Link to="/forgot-password" className="text-violet-300 hover:underline">Passwort vergessen</Link>
            {' · '}
            <Link to="/login" className="text-violet-300 hover:underline">Anmelden</Link>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-studio-bg px-4 py-6 safe-area-padding">
      <div className="card-glass w-full max-w-md p-6 sm:p-8">
        <div className="flex justify-center" aria-hidden>
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500 to-pink-500 text-2xl font-bold shadow-glow">◇</div>
        </div>
        <h1 className="mt-6 text-center text-2xl font-bold text-white">
          <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">Neues Passwort</span>
        </h1>
        <p className="mt-2 text-center text-white/60">Neues Passwort festlegen (min. 8 Zeichen)</p>
        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          {error && (
            <div role="alert" className="rounded-xl border border-red-500/40 bg-red-500/15 px-4 py-3 text-sm font-medium text-red-200">
              {error}
            </div>
          )}
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-white/80">Neues Passwort</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
              className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-white/40 focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20"
            />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-sm font-medium text-white/80">Passwort bestätigen</span>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              autoComplete="new-password"
              className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-white/40 focus:border-violet-500 focus:ring-2 focus:ring-violet-500/20"
            />
          </label>
          <button type="submit" className="btn-gradient w-full min-h-[48px] py-3 text-base" disabled={loading}>
            {loading ? 'Bitte warten…' : 'Passwort speichern'}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-white/70">
          <Link to="/login" className="text-violet-300 hover:underline">Zurück zur Anmeldung</Link>
        </p>
      </div>
    </div>
  )
}
